<clx-form #myForm>
    <clx-row type="buttons">
        <clx-item>
            <!-- <clx-button 
                routerLink="/Administration/ThirdPartyApps/Register" 
                i18n="@@third-party-apps.list.button.register-app"
                test-id="third-party-apps.button.register-app"
            >Register App</clx-button> -->
            <clx-button class="button-padding"
                routerLink="/Administration/ThirdPartyApps/Add" 
                i18n="@@third-party-apps.list.button.create-new"
                test-id="third-party-apps.button.create-new"
            >Create Third Party App</clx-button>
        </clx-item>
    </clx-row>
    <clx-data-grid [data]="dataSource" [showFilter]="false" [pageSize]="25" test-id="third-party-apps.grid.third-party-apps" id="third-party-apps" version="2" [remoteOperations]="remoteOperations">
        <clx-grid-column
            dataField="id"
            dataType="string"
            [visible]="false"
            [allowHiding]="false"
            [showInColumnChooser]="false"
            [allowSearch]="false"
        ></clx-grid-column>
        <clx-grid-column
            dataField="name"
            dataType="string"
            caption="Name"
            i18n-caption="@@third-party-apps.list.name.caption"
        >
            <ng-template let-cell="item">
                <a routerLink="/Administration/ThirdPartyApps/{{cell.data.id}}" title="{{cell.data.name}}">{{cell.data.name}}</a>
            </ng-template>
        </clx-grid-column>
        <clx-grid-column
            dataField="isEnabled"
            dataType="boolean"
            caption="Enabled"
            i18n-caption="@@third-party-apps.list.enabled.caption"
            [visible]="false"
            [showInColumnChooser]="false"
            [allowSorting]="false"
            [allowSearch]="false"
        >
            <ng-template let-cell="item">
                <span *ngIf="cell.data.isEnabled" class="fa fa-check success-icon-color"></span>
                <span  *ngIf="!cell.data.isEnabled" class="fa fa-remove error-icon-color"></span>
            </ng-template>
        </clx-grid-column>
        <clx-grid-column
            dataField="isPrimaryTenant"
            dataType="boolean"
            caption="Primary Tenant"
            i18n-caption="@@third-party-apps.list.primary-tenant.caption"
            [allowSorting]="false"
            [allowSearch]="false"
        >
            <ng-template let-cell="item">
                <span *ngIf="cell.data.isPrimaryTenant" class="fa fa-check success-icon-color"></span>
                <span  *ngIf="!cell.data.isPrimaryTenant" class="fa fa-remove error-icon-color"></span>
            </ng-template>
        </clx-grid-column>
        <clx-grid-column
            dataField="clientUri"
            dataType="string"
            caption="Client Uri"
            i18n-caption="@@third-party-apps.list.client-uri.caption"
            [allowSorting]="false"
            [allowSearch]="false"
        ></clx-grid-column>
        <!-- <clx-grid-column
            dataField="logoUri"
            dataType="string"
            caption="Logo Uri"
            i18n-caption="@@third-party-apps.list.logo-uri.caption"
        ></clx-grid-column> -->
    </clx-data-grid>
</clx-form>